import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { StepPicker } from '../../builder/step-picker';
import { INTERACTIVE } from './card';
import { Port } from './port';

export const AddNode = () => (
	<div className={cn(INTERACTIVE, 'relative h-8 w-full')}>
		<Port type='target' side='left' tone='hidden' connectable={false} />
		<StepPicker>
			<button
				type='button'
				className='flex h-full w-full items-center justify-center gap-1.5 rounded-full border border-dashed border-gray-600 bg-white text-xs leading-4 text-gray-900 hover:bg-gray-50'
			>
				<Plus className='size-3.5' aria-hidden />
				Add tool
			</button>
		</StepPicker>
	</div>
);
